import type { ProjectSearchDtoSortByEnumKey, ProjectSearchPattern } from "@synthesis/shared-services/project-gge/projectSearchController/types";

export type SearchDto = Record<string, ProjectSearchPattern>;

export type FilterFieldName = "TITLE" | "ORGANIZATION" | "EXTERNAL_ID";

export const DEFAULT_PROJECTS_PAGE_SIZE = 20;

export const PROJECTS_SORT_FIELD_MAP: Record<string, ProjectSearchDtoSortByEnumKey> = {
  date: "CREATED_AT",
  meta: "EXTERNAL_ID",
  title: "TITLE",
  objectName: "ORGANIZATION",
};

export const getProjectsSearchPage = (startRow: number | undefined, pageSize: number): number => {
  const size = Math.max(1, pageSize);

  return Math.floor((startRow ?? 0) / size) + 1;
};
